import { Transition } from "../../../../core/flows/Transition";
import { TicketOptionContext } from "../Context/TicketOptionContext";


export class TicketOptionTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {        
        const context = this.getCtx<TicketOptionContext>("ticketOptionContext", this.entryStep);
        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        /**
         * This is because form the ticket option flow we need to start again,
         * select offer and ticket option flow and those values are hold into,
         * context.nextTo variable.
        */
        if (context.nextTo.length > 0) {
            context.routeTo = context.nextTo
            context.nextTo = []
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${context.routeTo}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }

}